import color from 'color';
// Parameters<typeof color>[0]
export const toString = places => colorParam => color(colorParam).string(places);
export const toPercentString = places => colorParam => color(colorParam).percentString(places);
export const toArray = colorParam => color(colorParam).array();
export const toObject = colorParam => color(colorParam).rgb().string();
export const toUnitArray = colorParam => color(colorParam).unitArray();
export const toUnitObject = colorParam => color(colorParam).unitObject();
export const round = places => colorParam => color(colorParam).round(places).rgb().string();
export const getRound = colorParam => color(colorParam).round();
export const alpha = val => colorParam => color(colorParam).alpha(val).rgb().string();
export const getAlpha = colorParam => color(colorParam).alpha();
export const red = val => colorParam => color(colorParam).red(val).rgb().string();
export const getRed = colorParam => color(colorParam).red();
export const green = val => colorParam => color(colorParam).green(val).rgb().string();
export const getGreen = colorParam => color(colorParam).green();
export const blue = val => colorParam => color(colorParam).blue(val).rgb().string();
export const getBlue = colorParam => color(colorParam).blue();
export const hue = val => colorParam => color(colorParam).hue(val).rgb().string();
export const getHue = colorParam => color(colorParam).hue();
export const saturationl = val => colorParam => color(colorParam).saturationl(val).rgb().string();
export const getSaturationl = colorParam => color(colorParam).saturationl();
export const lightness = val => colorParam => color(colorParam).lightness(val).rgb().string();
export const getLightness = colorParam => color(colorParam).lightness();
export const saturationv = val => colorParam => color(colorParam).saturationv(val).rgb().string();
export const getSaturationv = colorParam => color(colorParam).saturationv();
export const value = val => colorParam => color(colorParam).value(val).rgb().string();
export const getValue = colorParam => color(colorParam).value();
export const chroma = val => colorParam => color(colorParam).chroma(val).rgb().string();
export const getChroma = colorParam => color(colorParam).chroma();
export const gray = val => colorParam => color(colorParam).gray(val).rgb().string();
export const getGray = colorParam => color(colorParam).gray();
export const white = val => colorParam => color(colorParam).white(val).rgb().string();
export const getWhite = colorParam => color(colorParam).white();
export const wblack = val => colorParam => color(colorParam).wblack(val).rgb().string();
export const getWblack = colorParam => color(colorParam).wblack();
export const cyan = val => colorParam => color(colorParam).cyan(val).rgb().string();
export const getCyan = colorParam => color(colorParam).cyan();
export const magenta = val => colorParam => color(colorParam).magenta(val).rgb().string();
export const getMagenta = colorParam => color(colorParam).magenta();
export const yellow = val => colorParam => color(colorParam).yellow(val).rgb().string();
export const getYellow = colorParam => color(colorParam).yellow();
export const black = val => colorParam => color(colorParam).black(val).rgb().string();
export const getBlack = colorParam => color(colorParam).black();
export const x = val => colorParam => color(colorParam).x(val).rgb().string();
export const getX = colorParam => color(colorParam).x();
export const y = val => colorParam => color(colorParam).y(val).rgb().string();
export const getY = colorParam => color(colorParam).y();
export const z = val => colorParam => color(colorParam).z(val).rgb().string();
export const getZ = colorParam => color(colorParam).z();
export const l = val => colorParam => color(colorParam).l(val).rgb().string();
export const getL = colorParam => color(colorParam).l();
export const a = val => colorParam => color(colorParam).a(val).rgb().string();
export const getA = colorParam => color(colorParam).a();
export const b = val => colorParam => color(colorParam).b(val).rgb().string();
export const getB = colorParam => color(colorParam).b();
export const keyword = val => colorParam => color(colorParam).keyword(val).rgb().string();
export const getKeyword = colorParam => color(colorParam).keyword();
export const hex = val => colorParam => color(colorParam).hex(val).rgb().string();
export const rgbNumber = colorParam => color(colorParam).rgbNumber();
export const luminosity = colorParam => color(colorParam).luminosity();
export const contrast = colorParam2 => colorParam => color(colorParam).contrast(color(colorParam2));
export const level = colorParam2 => colorParam => color(colorParam).level(color(colorParam2));
export const isDark = colorParam => color(colorParam).isDark();
export const isLight = colorParam => color(colorParam).isLight();
export const negate = colorParam => color(colorParam).negate().rgb().string();
export const lighten = ratio => colorParam => color(colorParam).lighten(ratio).rgb().string();
export const darken = ratio => colorParam => color(colorParam).darken(ratio).rgb().string();
export const saturate = ratio => colorParam => color(colorParam).saturate(ratio).rgb().string();
export const desaturate = ratio => colorParam => color(colorParam).desaturate(ratio).rgb().string();
export const whiten = ratio => colorParam => color(colorParam).whiten(ratio).rgb().string();
export const blacken = ratio => colorParam => color(colorParam).blacken(ratio).rgb().string();
export const grayscale = colorParam => color(colorParam).grayscale().rgb().string();
export const fade = ratio => colorParam => color(colorParam).fade(ratio).rgb().string();
export const opaquer = ratio => colorParam => color(colorParam).opaquer(ratio).rgb().string();
export const rotate = degrees => colorParam => color(colorParam).rotate(degrees).rgb().string();
export const mix = (mixinColor, weight) => colorParam => color(colorParam).mix(color(mixinColor), weight).rgb().string();
export const rgb = colorParam => color(colorParam).rgb().string();
export const hsl = colorParam => color(colorParam).hsl().string();
export const hsv = colorParam => color(colorParam).hsv().string();
export const hwb = colorParam => color(colorParam).hwb().string();
export const cmyk = colorParam => color(colorParam).cmyk().string();
export const xyz = colorParam => color(colorParam).xyz().string();
export const lab = colorParam => color(colorParam).lab().string();
export const lch = colorParam => color(colorParam).lch().string();
export const ansi16 = colorParam => color(colorParam).ansi16().string();
export const ansi256 = colorParam => color(colorParam).ansi256().string();
export const hcg = colorParam => color(colorParam).hcg().string();
export const apple = colorParam => color(colorParam).apple().string();